/* eslint-disable jsx-a11y/anchor-has-content */
import type { LinkProps as LinkPropsType } from '@tbitop/routing';
import { omit } from 'lodash-es';
import type { MouseEvent, PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import type { LinkProps as ReactRouterLinkProps } from 'react-router-dom';
import { Link as ReactRouterLink } from 'react-router-dom';
import { toLocationDescriptor } from './location-descriptor';

type LinkProps = LinkPropsType & {
  options?: LinkPropsType['options'] & Omit<ReactRouterLinkProps, 'to'>;
};

export const Link = forwardRef<HTMLAnchorElement, PropsWithChildren<LinkProps>>((props, ref) => {
  const linkProps = omit(props, 'href', 'options');

  const handleClick = (event: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>) => {
    props.onClick?.(event);

    if (props.options?.scroll) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <ReactRouterLink
      ref={ref}
      to={toLocationDescriptor(props.href)}
      onClick={handleClick}
      {...omit(linkProps, 'onClick')}
      {...omit(props.options, 'to', 'scroll')}
    />
  );
});
